import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'

import { selectCurrentPhoneId } from '../App/selectors'
import { selectAllDevices } from '../DeviceSelector/selectors'
import { updatePhoneId, clearContent } from '../App/actions'
import { InlineLoader } from '../../components'
import { useLocalStorageState } from '../../hooks'

const DeviceLoader = ({
  children,
  location,
  devices,
  updateDeviceId,
  currentPhoneId,
  clearContent,
}) => {
  const { query: { device: queryDevice } } = location
  useEffect(() => clearContent, [queryDevice])
  const [currPhoneId, setCurrPhoneId] = useLocalStorageState('currentPhoneId', currentPhoneId)

  useEffect(() => {
    if (currentPhoneId) {
      setCurrPhoneId(currentPhoneId)
    }
  }, [currentPhoneId])

  useEffect(() => {
    if (queryDevice && devices.length) {
      const deviceBySlug = devices.find(item => item.slug === queryDevice)
      if (deviceBySlug) {
        updateDeviceId(deviceBySlug.id)
        return
      }

      const deviceById = devices.find(
        item => parseInt(item.id, 10) === parseInt(queryDevice, 10)
      )
      if (deviceById) {
        updateDeviceId(null)
        browserHistory.replace({
          pathname: location.pathname,
          query: {
            ...location.query,
            device: deviceById.slug
          }
        })
        return
      }
      // if no device find redirect to 404
      browserHistory.replace('/404')
    }
  }, [queryDevice, devices.length])

  if (queryDevice && !currentPhoneId) {
    return <InlineLoader />
  }
  return children
}


const mapStateToProps = (state) => ({
  devices: selectAllDevices(state),
  currentPhoneId: selectCurrentPhoneId(state),
})

const mapDispatchToProps = dispatch => ({
  updateDeviceId: (phoneId, deviceName) =>
    dispatch(updatePhoneId(phoneId, deviceName)),
  clearContent: () => dispatch(clearContent())
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeviceLoader)



// WEBPACK FOOTER //
// ./src/containers/DeviceLoader/index.js